module.exports = __webpack_public_path__ + "img/photo-0126.b068f9ec.jpg";